import {
  type StepsDefinition,
  type DomAnimationHelper,
  type HelperAwaiter,
} from "./useDomAnimationHelper.types.js";
import {
  OnImmediate,
  onElementAnimated,
  OnAnimationFrame,
} from "./useDomAnimationHelper.awaiter.js";
import {
  getStepsNormalizer,
  processAnimationSteps,
  type InternalState,
} from "./useDomAnimationHelper.utils.js";

/*                       */
export * from "./useDomAnimationHelper.awaiter.js";
export * from "./useDomAnimationHelper.types.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useDomAnimationHelper = <Steps extends StepsDefinition>(
  stepsDefinition: Steps,
): DomAnimationHelper<Steps> => {
  /*                                             */
  /*                                                                    */
  const state = $state<InternalState>({ $animIn: false, $animOut: false, $direction: undefined });

  /*                                  */
  const toggleProcess = processAnimationSteps.bind(
    state,
    /*                                       */
    Object.keys(stepsDefinition).map((step) => {
      /*                                           */
      state[step] = false;
      return step;
    }),
    /*                                       */
    getStepsNormalizer(stepsDefinition),
  );

  return [state as never, toggleProcess, () => toggleProcess(true), () => toggleProcess(false)];
};

/**
 *
 *
 *
 *
 *
 *
 */
export const useSimpleDomAnimationHelper = (
  getAnimatedElements: () => Element[] | HTMLCollection | null | undefined,
  getAnimationsOptions?: Parameters<HTMLElement["getAnimations"]>[0],
): DomAnimationHelper<{
  active: [HelperAwaiter, HelperAwaiter];
  ready: HelperAwaiter;
  done: [HelperAwaiter, HelperAwaiter];
}> => {
  const OnAnimated = onElementAnimated(getAnimatedElements, getAnimationsOptions);
  return useDomAnimationHelper({
    active: [OnImmediate, OnAnimated],
    ready: OnAnimationFrame,
    done: [OnAnimated, OnImmediate],
  });
};
